/**
 * Cookie Consent Banner - Two-Step Flow with 4-Category Preferences
 *
 * Step 1: Banner with "Accept All" button and "Manage Cookies" link.
 * Step 2: Modal with 4 expandable cookie categories (Essential, Performance,
 *         Functional, Targeting) with independent toggles.
 *
 * Posts to the existing /customer_privacy/update_optin_optout endpoint
 * with 3 category preferences, then reloads the page.
 *
 * Auto-included in website bundle via gulp glob.
 * Only runs when the banner element exists on the page (no WebPageObj guard needed).
 */
(function() {
    var $banner = $('#cookieConsentBanner');
    if (!$banner.length) return;

    var $acceptBtn = $('#cookieConsentAccept');
    var $manageLink = $('#cookieConsentManage');
    var $confirmBtn = $('#cookieConsentConfirm');
    var $modal = $('#cookieConsentModal');
    var $togglePerformance = $('#consentTogglePerformance');
    var $toggleFunctional = $('#consentToggleFunctional');
    var $toggleTargeting = $('#consentToggleTargeting');
    var isSubmitting = false;

    function submitConsent(preferences) {
        if (isSubmitting) return;
        isSubmitting = true;

        $acceptBtn.prop('disabled', true);
        $confirmBtn.prop('disabled', true);

        $.ajax({
            url: '/customer_privacy/update_optin_optout',
            method: 'POST',
            data: preferences,
            dataType: 'json',
            success: function() {
                location.reload();
            },
            error: function(xhr, textStatus, error) {
                isSubmitting = false;
                $acceptBtn.prop('disabled', false);
                $confirmBtn.prop('disabled', false);

                $('#cookieConsentFeedback').html('Unable to save your preference. Please try again.');
                console.error('Consent submission failed:', textStatus, error);
            }
        });
    }

    // Step 1: Accept All — grant all 3 categories
    $acceptBtn.on('click', function() {
        submitConsent({ performance: 1, functional: 1, targeting: 1 });
    });

    // Step 1: Manage Cookies — open modal, hide banner
    $manageLink.on('click', function(e) {
        e.preventDefault();
        $banner.hide();
        $modal.modal('show');
    });

    // Step 2: Confirm My Choices — read all 3 toggles
    $confirmBtn.on('click', function() {
        submitConsent({
            performance: $togglePerformance.is(':checked') ? 1 : 0,
            functional: $toggleFunctional.is(':checked') ? 1 : 0,
            targeting: $toggleTargeting.is(':checked') ? 1 : 0
        });
    });

    // If modal is closed without confirming, reset toggles to ON and show banner again
    $modal.on('hidden.bs.modal', function() {
        if (!isSubmitting) {
            $togglePerformance.prop('checked', true).attr('aria-checked', 'true');
            $toggleFunctional.prop('checked', true).attr('aria-checked', 'true');
            $toggleTargeting.prop('checked', true).attr('aria-checked', 'true');
            $banner.show();
        }
    });
})();